export const SURVEY_STATUS = {
  QUOTAFULL: 'quotafull',
};
